import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import soundsMiddleware from "./middleware/soundsMiddleware";
import soundsData from "./soundsData";
import gameApp from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";

// Pre-load our middleware with our sounds data.
const loadedSoundsMiddleware = soundsMiddleware(soundsData);

const isProd = () => process.env.NODE_ENV === "production"
const applyMW = () => applyMiddleware( thunk, loadedSoundsMiddleware )

export const store = createStore( gameApp, isProd() ? applyMW() : composeWithDevTools( applyMW() ) );


// WEBPACK FOOTER //
// ./src/store.js